import { render, staticRenderFns } from "./RequisiteSetModal.vue?vue&type=template&id=065d5686"
import script from "./RequisiteSetModal.vue?vue&type=script&lang=js"
export * from "./RequisiteSetModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports